"use client";

import React from "react";
import { Linkedin, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const teamMembers = [{
  id: 1,
  name: "Leading the label with Creative thinking and Innovative thinking",
  role: "FOUNDER, CREATIVE DIRECTOR & ARTIST\xA0",
  imageSrc: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Ethan-Heaven-Artist-Picture.png?v=mjxx4g0wow",
  imageSrcset: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Ethan-Heaven-Artist-Picture.png?v=ysm7rkx4k4k-wvc-srcset",
  imageSizes: "https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Ethan-Heaven-Artist-Picture.png?v=3rlwzcnno5p-wvc-sizes",
  linkedin: "https://linkedin.com",
  email: "mailto:ethanheaven@heavenshorizonrecords.com"
}];
export default function Founders() {
  return <section data-section-id="262532" id="founders" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold text-foreground mb-4 tracking-widest">
            The Visionaries
          </h2>
          <p className="font-default text-muted-foreground max-w-2xl mx-auto text-lg font-light">
            The architects behind the sound, dedicated to pushing the boundaries of electronic music and artist development.
          </p>
        </div>

        <div className="flex flex-col items-center gap-8">
          {teamMembers.map((member, i) => <Card key={member.id} data-index={i} className="group border-border/50 shadow-lg hover:shadow-xl hover:shadow-accent/20 backdrop-blur-md transition-all duration-500 text-center bg-card/80 rounded-lg">
              <CardHeader className="pt-8 pb-4 flex flex-col items-center gap-0">
                <div className="w-32 h-32 mb-5 overflow-hidden rounded-lg border-2 border-accent/30 shadow-md relative">
                  <div className="absolute inset-0 bg-gradient-to-tr from-accent/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                  <img src={member.imageSrc} data-wvc-srcset={member.imageSrcset} data-wvc-sizes={member.imageSizes} alt={`Portrait of ${member.name}`} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" loading="lazy" />
                </div>
                <CardTitle className="font-default text-2xl font-bold text-foreground mb-2 tracking-wider">
                  {member.name}
                </CardTitle>
                <CardDescription className="bg-accent/10 text-accent-foreground text-xs font-bold px-3 py-1 rounded-lg uppercase tracking-widest">
                  {member.role}
                </CardDescription>
              </CardHeader>
              <CardContent className="pb-8">
                <p className="font-default text-muted-foreground text-sm font-light mb-6 px-4">
                  Leading the label with a focus on sonic innovation and global community building.
                </p>
                <div className="flex justify-center gap-2">
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button variant="ghost" size="icon" asChild className="text-foreground hover:text-accent hover:bg-accent/10 rounded-lg transition-colors">
                          
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>LinkedIn Profile</p>
                      </TooltipContent>
                    </Tooltip>

                    <Tooltip>
                      <TooltipTrigger asChild>
                        <Button variant="ghost" size="icon" asChild className="text-foreground hover:text-accent hover:bg-accent/10 rounded-lg transition-colors">
                          <Link to={member.email}>
                            <Mail className="w-5 h-5" />
                            <span className="sr-only">
                              Email {member.name}
                            </span>
                          </Link>
                        </Button>
                      </TooltipTrigger>
                      <TooltipContent>
                        <p>Send Email</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}